import React, { useState, Component } from 'react';
import NewsTextBox from '../Atoms/NewsTextBox';
import TextBox from '../Atoms/TextBox';
import MediaCard from './MediaCard';
import { client } from '../../client';
import { Link } from 'react-router-dom'




class List extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);
   
    this.state = {
      isHovered: false,
      listData : [],
      category : ''
    };

    // This binding is necessary to make `this` work in the callback
    this.handleHover = this.handleHover.bind(this);

  }

  handleHover = () => this.setState({ isHovered: !this.state.isHovered });
  

  //this is where we receive API calls inside components
  componentDidMount() {
    this.fetchListItems(this.props.category)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.category != this.props.category)
        this.fetchListItems(this.props.category);
  }


  
fetchListItems (category) {

  // console.log("typeOfListItems", typeOfListItems)
  client.getEntries({
    content_type: category
  })
    .then((response) => {
      this.setState({
        listData : response.items,
        order: 'sys.createdAt'
        // category: category
        
      })  
  })
  
  .catch(console.error)
}




  //TODO: HOW IS NEWS SHOWED WHEN OTHERS ARE NOT?

  render() {
    // console.log(listData[0].sys.contentType.sys.id)
    // todo: console.log(this.props.match.params.id)
    
    // const {data, category} = this.props;
    
//  console.log(this.props.listData[1].metadata.tags)
    
    

// componentDidUpdate() {
  
// }
    

  
    return(<div className="h-101">
      

          
          { this.props.category == 'news' ? 
            this.state.listData.map((listItem, index) => (
                 
                  <Link to={`/nyheder/${listItem.sys.id}`} className="flex phone-h-15" key={index}>
                    <NewsTextBox cx={` bb flex-3`} title={listItem.fields.newsTitle} excerpt={listItem.fields.newsExcerpt} date={listItem.fields.newsDate} key={index}/>
                    <div className="flex-1 items-center flex justify-content-end bb pr-m">NYHED</div>
                  </Link>
                 
                 
                ) 
              )
            :
            ""
            }

          { this.props.category == 'workItem' ? 
            this.state.listData.map((listItem, index) => (
                 
                  <Link to={`/post/${listItem.sys.id}`} className="flex" key={index}>
                    <TextBox firstLevel="h3" secondLevel="i" thirdLevel="p" cx="flex-3" border="bb" firstContent={`${listItem.fields.title} (${listItem.fields.year})`} secondContent={listItem.fields.titleEnglish} thirdContent={listItem.fields.exhibitionPlace}/>
                    <div className={`flex-1 items-center flex justify-content-end bb pr-m uppercase `}>{listItem.metadata.tags[0] ? listItem.metadata.tags[0].sys.id : "VÆRK"}</div>
                  </Link>
                 
                 
                ) 
              )
            :
            ""
            }

          { this.props.category == 'curationItem' ? 
            this.state.listData.map((listItem, index) => (
                 
                  <Link to={`/post/${listItem.sys.id}`} className="flex" key={index}>
                    <TextBox firstLevel="h3" secondLevel="i" thirdLevel="p" cx="flex-3" border="bb" firstContent={`${listItem.fields.title} (${listItem.fields.year})`} secondContent={listItem.fields.titleEnglish} thirdContent={listItem.fields.exhibitionPlace}/>
                    <div className="flex-1 items-center flex justify-content-end bb pr-m">KURATERING</div>
                  </Link>
                 
                 
                ) 
              )
            :
            ""
            }


            
     
    </div>
    
    );
    


  }
}


export default List;    


